import React from 'react';
import { Link } from 'react-router-dom';
import { Card } from '../../components/ui/Card';
const enrolledCourses = [{
  name: 'Mastering Agency Agreements',
  creditType: '3 hrs. Agency Law',
  status: 'in_progress',
  dateEnrolled: '11/09/2025'
}, {
  name: 'The Bottom Line of Disclosure',
  creditType: '3 hrs. Disclosure',
  status: 'in_progress',
  dateEnrolled: '07/27/2025'
}, {
  name: 'Avoid The Oops: Contract Smarts for Agents',
  creditType: '3 hrs. Contract Law',
  status: 'in_progress',
  dateEnrolled: '07/02/2025'
}, {
  name: 'BMC #3B Property Management',
  creditType: '3 hrs. Req. For Licensees',
  status: 'section_progress',
  dateEnrolled: '07/02/2025'
}, {
  name: 'Ethics & The Rules (with NAR Code of Ethics)',
  creditType: '3 hrs. Req. For Licensees',
  status: 'section_progress',
  dateEnrolled: '06/22/2025'
}, {
  name: 'Deeds, Fires & Water: Be Prepared',
  creditType: '3 hrs. General',
  status: 'in_progress',
  dateEnrolled: '05/12/2025'
}, {
  name: 'Accidental Property Management',
  creditType: '3 hrs. Legal Issues',
  status: 'in_progress',
  dateEnrolled: '05/10/2025'
}, {
  name: 'BMC #3 AZ Residential-Broker Supervision',
  creditType: '3 hrs. Req. For Licensees',
  status: 'in_progress',
  dateEnrolled: '05/10/2025'
}, {
  name: 'BMC #2 AZ Residential-Broker Policies',
  creditType: '3 hrs. Req. For Licensees',
  status: 'in_progress',
  dateEnrolled: '05/10/2025'
}, {
  name: 'BMC #1 AZ Residential-Statutes and Rules',
  creditType: '3 hrs. Req. For Licensees',
  status: 'in_progress',
  dateEnrolled: '05/10/2025'
}, {
  name: "Don't Lose Your License",
  creditType: '3 hrs. Req. For Licensees',
  status: 'in_progress',
  dateEnrolled: '05/10/2025'
}, {
  name: 'A Letter From ADRE',
  creditType: '3 hrs. Req. For Licensees',
  status: 'in_progress',
  dateEnrolled: '05/10/2025'
}, {
  name: 'Client or Customer Representation',
  creditType: '3 hrs. Agency Law',
  status: 'in_progress',
  dateEnrolled: '05/10/2025'
}, {
  name: 'Are They Represented?',
  creditType: '3 hrs. Agency Law',
  status: 'in_progress',
  dateEnrolled: '02/20/2025'
}, {
  name: 'What Goes Wrong In Contracts',
  creditType: '3 hrs. Contract Law',
  status: 'in_progress',
  dateEnrolled: '08/13/2024'
}, {
  name: 'Follow All The Laws',
  creditType: '3 hrs. Legal Issues',
  status: 'in_progress',
  dateEnrolled: '08/13/2024'
}, {
  name: 'They Are A Protected Class',
  creditType: '3 hrs. Fair Housing',
  status: 'in_progress',
  dateEnrolled: '05/08/2024'
}, {
  name: 'Your Clients Are Not Mushrooms',
  creditType: '3 hrs. Disclosure',
  status: 'in_progress',
  dateEnrolled: '03/03/2023'
}, {
  name: "Fair Housing In Today's World",
  creditType: '3 hrs. Fair Housing',
  status: 'in_progress',
  dateEnrolled: '03/03/2023'
}, {
  name: 'How Contracts Work',
  creditType: '3 hrs. Contract Law',
  status: 'in_progress',
  dateEnrolled: '03/03/2023'
}, {
  name: 'The Owner Is In Default',
  creditType: '3 hrs. Legal Issues',
  status: 'in_progress',
  dateEnrolled: '03/03/2023'
}, {
  name: 'NAR Code of Ethics (NO CE CREDIT)',
  creditType: 'NONE',
  status: 'in_progress',
  dateEnrolled: '01/30/2022'
}, {
  name: 'Fair Housing Facts',
  creditType: '3 hrs. Fair Housing',
  status: 'in_progress',
  dateEnrolled: '02/24/2020'
}, {
  name: 'No Secrets',
  creditType: '3 hrs. Disclosure',
  status: 'in_progress',
  dateEnrolled: '12/15/2017'
}];
export function MyClasses() {
  return <div className="space-y-4" data-id="element-2222">
      <div className="rounded-xl px-6 py-5 text-white" style={{
      backgroundColor: '#4A2D8F'
    }} data-id="element-2223">
        <h1 className="text-2xl font-extrabold tracking-tight mb-1" data-id="element-2224">
          My Classes
        </h1>
        <p className="text-purple-200 text-sm" data-id="element-2225">
          Track your currently enrolled courses and continue where you left off.
        </p>
      </div>

      <Card className="overflow-hidden rounded-none border-slate-300" data-id="element-2226">
        <div className="overflow-x-auto" data-id="element-2227">
          <table className="w-full text-sm text-left" data-id="element-2228">
            <thead style={{
            backgroundColor: '#4A2D8F'
          }} className="text-white font-medium" data-id="element-2229">
              <tr data-id="element-2230">
                <th className="px-4 py-3 border-r border-purple-700" data-id="element-2231">Class</th>
                <th className="px-4 py-3 border-r border-purple-700 w-56 whitespace-nowrap" data-id="element-2232">
                  Credit Type
                </th>
                <th className="px-4 py-3 border-r border-purple-700" data-id="element-2233">Status</th>
                <th className="px-4 py-3 w-32" data-id="element-2234">Date Enrolled</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-slate-200" data-id="element-2235">
              {enrolledCourses.map((course, i) => <tr key={i} className="hover:bg-purple-50/20" data-id="element-2236">
                  <td className="px-4 py-2.5 border-r border-slate-200" data-id="element-2237">
                    <Link to={`/student/class/${course.name.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/(^-|-$)/g, '')}`} className="text-blue-600 hover:underline text-left" data-id="element-2238">
                      {course.name}
                    </Link>
                  </td>
                  <td className="px-4 py-2.5 border-r border-slate-200 text-slate-700" data-id="element-2239">
                    {course.creditType}
                  </td>
                  <td className="px-4 py-2.5 border-r border-slate-200 text-slate-700" data-id="element-2240">
                    {course.status === 'section_progress' ? <span data-id="element-2241">Section in progress</span> : <span data-id="element-2242">
                        Course in progress{' '}
                        <Link to={`/student/class/${course.name.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/(^-|-$)/g, '')}/final-exam`} className="text-blue-600 hover:underline whitespace-nowrap" data-id="element-2243">
                          (Take the final exam)
                        </Link>
                      </span>}
                  </td>
                  <td className="px-4 py-2.5 text-slate-700" data-id="element-2244">
                    {course.dateEnrolled}
                  </td>
                </tr>)}
            </tbody>
          </table>
        </div>
      </Card>
    </div>;
}